export const getParams = state => {
  return state.params
}

export const getUserInfo = state => {
  return state.user_info
}



// WEBPACK FOOTER //
// ./src/store/getters.js